import React from 'react'
import { MaskedInput, MaskedInputProps } from 'rsuite'

const options = {
  mask: [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  placeholder: '(555) 555-5555',
}

export const PhoneInput: React.FC<MaskedInputProps> = (
  props: MaskedInputProps,
): React.ReactElement => {
  return <MaskedInput {...options} {...props} />
}
